import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  text: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
  cardContainer: {
    marginBottom: '3vw',
    width: '90%',
    height: '10%',
    backgroundColor: '#0F6657',
    borderColor: '#0F6657',
  },
  cardItemLarge: {
    width: '90%',
    marginTop: 100,
    backgroundColor: '#fff',
    paddingTop: 10,
    paddingBottom: 10,
    flexDirection: 'row',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  cardItemSmall: {
    width: '90%',
    marginTop: 15,
    backgroundColor: '#fff',
    paddingTop: 10,
    paddingBottom: 10,
    flexDirection: 'row',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  orderIdVisualization: {
    flex: 1,
    textAlign: 'center',
  },
  orderIdVisualizationSize: {
    fontSize: 128,
    fontWeight: "500",
    lineHeight: 43,
    letterSpacing: 7.0,
    textAlign: "center",
  },
  orderIdVisualizationSizeMedium: {
    fontSize: 90,
    fontWeight: "500",
    lineHeight: 43,
    letterSpacing: 4.0,
    textAlign: "center",
  },

  orderIdVisualizationSizeSmall: {
    fontSize: 70,
    fontWeight: "500",
    lineHeight: 43,
    letterSpacing: 2.25,
    textAlign: "center",
  },
  orderIdVisualizationDeliverySize: {
    marginTop: 35,
    fontSize: 43,
    fontWeight: "500",
    lineHeight: 43,
    letterSpacing: 4.25,
    textAlign: "center",
  },

  orderIdVisualizationDeliverySizeMedium: {
    marginTop: 35,
    fontSize: 35,
    fontWeight: "500",
    lineHeight: 43,
    letterSpacing: 2.25,
    textAlign: "center",
  },
  orderId: {
    flex: 0.4,
    textAlign: 'center',
    fontSize: 15,
    alignItems: 'center',
  },
  cardBtnContainer: {
    flex: 0.6,
  },
  cardBtn: {
    color: '#fff',
    backgroundColor: '#0F6657',
    borderRadius: 12,
    alignSelf: 'center',
    width: '70%',
  },
  cardBtnTitle: {
    fontWeight: 'bold',
    fontSize: 10,
    lineHeight: 9,
  },
});
